
import { useEffect } from "react";

const ResourcePreload = () => {
  useEffect(() => {
    // Preload critical images
    const imagesToPreload = [
      '/lovable-uploads/d525a06b-276a-466a-b683-e3f464bd460e.webp', // New author image
    ];
    
    const preloadedImages = imagesToPreload.map(src => {
      const img = new Image();
      img.src = src;
      return img;
    });
    
    const linkRels = [
      { rel: 'preconnect', href: 'https://images.unsplash.com' }
    ];
    
    const links = linkRels.map(({ rel, href }) => {
      const link = document.createElement('link');
      link.rel = rel;
      link.href = href;
      document.head.appendChild(link);
      return link;
    });
    
    return () => {
      links.forEach(link => {
        if (document.head.contains(link)) {
          document.head.removeChild(link);
        }
      });
    };
  }, []);

  return null;
};

export default ResourcePreload;
